import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';
import BoardOfDirectors from "../fields/BoardOfDirectors";

let boardLeadershipArray = [];
let staffArray = [];
let boardOfDirectorsArray = [[], [], [], []] //we'll create 4 arrays here

function findChairs(staffMembers) {
    let staffPerson;

    boardLeadershipArray = [];
    staffArray = [];

    for (staffPerson in staffMembers) {
        if (staffMembers[staffPerson].staff_member_item.position.toLowerCase().includes('chair')) {
            boardLeadershipArray.push(staffMembers[staffPerson]);
        } else {
            staffArray.push(staffMembers[staffPerson]);
        }
    }
}

function setBoardOfDirectorsColumns(boardOfDirectors) {
    let columnMax = Math.ceil(boardOfDirectors.length/4)
    let director;

    boardOfDirectorsArray = [[], [], [], []]

    for (director in boardOfDirectors) {
        if (director < columnMax) {
            // let tempArray = boardOfDirectorsArray[0];
            // tempArray.push(boardOfDirectors[director]);
            // boardOfDirectors[0] = tempArray;
            boardOfDirectorsArray[0].push(boardOfDirectors[director]);
        } else if (director < columnMax*2) {
            boardOfDirectorsArray[1].push(boardOfDirectors[director]);
        } else if (director < columnMax*3) {
            boardOfDirectorsArray[2].push(boardOfDirectors[director]);
        } else if (director < columnMax*4) {
            boardOfDirectorsArray[3].push(boardOfDirectors[director]);
        }
    }
}

function DefaultPageTemplateLeadershipBody({ data }) {
    findChairs(data.staffMembers);
    setBoardOfDirectorsColumns(data.boardOfDirectors);

    return (
        <div key={data.documentId} className="default-page-template-leadership-body col-sm-12 col-xs-12">
            <div className="row">
                <div className="container-fluid no-padding default-template-container">
                    <div className="col-sm-12 leadership-padding col-xs-12">
                        <div className="row leadership-title-text">
                            <div className="section-headline light-blue-text" style={{maxWidth: 'none'}}>
                                Board Leadership
                            </div>
                        </div>
                        {boardLeadershipArray.map((item, index) => (
                            <div className="row leadership-profiles" style={{display: 'inline-grid', gridTemplateColumns: '25% auto'}}>
                                <div className="leadership-column-1">
                                    <img alt="board leadership" className="img-responsive"
                                         src={item.staff_member_item.photo.url}
                                         style={{maxWidth: '100%'}}/>
                                </div>
                                <div className="leadership-column-2">
                                    <p className="section-headline-small light-blue-text staff-name">{item.staff_member_item.name}</p>
                                    <p className="body-text">{item.staff_member_item.position}</p>
                                    <p className="body-text" style={{color: 'lightgrey'}}>
                                    </p>
                                    <p className="body-text" style={{maxWidth: '550px'}}>
                                        {item.staff_member_item.bio}
                                    </p>
                                </div>
                            </div>
                        ))}

                        <div className="row leadership-title-text">
                            <div className="section-headline light-blue-text" style={{maxWidth: 'none'}}>
                                Staff
                            </div>
                        </div>

                        {staffArray.map((item, index) => (
                            <div className="row leadership-profiles" style={{display: 'inline-grid', gridTemplateColumns: '25% auto'}}>
                                <div className="leadership-column-1">
                                    <img alt="board leadership" className="img-responsive"
                                         src={item.staff_member_item.photo.url}
                                         style={{maxWidth: '100%'}}/>
                                </div>
                                <div className="leadership-column-2">
                                    <p className="section-headline-small light-blue-text staff-name">{item.staff_member_item.name}</p>
                                    <p className="body-text">{item.staff_member_item.position}</p>
                                    <p className="body-text" style={{color: 'lightgrey'}}>
                                    </p>
                                    <p className="body-text" style={{maxWidth: '550px'}}>
                                        {item.staff_member_item.bio}
                                    </p>
                                </div>
                            </div>
                        ))}

                    </div>
                </div>

                <div className="row light-gray-background" style={{width: '100%', marginLeft: '-10%'}}>
                    <div className="container-fluid no-padding board-member-container"
                         style={{maxWidth: '1330px', margin: '0 auto', padding: '0 60px'}}>
                        <div className="col-xs-12 board-title-text">
                            <div className="section-headline light-blue-text"
                                 style={{maxWidth: 'none', paddingBottom: '15px'}}>
                                Board of Directors
                            </div>
                            <div className="col-xs-12 no-padding" style={{display: 'inline-flex'}}>
                                {boardOfDirectorsArray.map((item, index) => (
                                    <BoardOfDirectors data={item}/>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DefaultPageTemplateLeadershipBody;
